/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseStatus } from './CaseStatus';
import {
    CaseStatusFromJSON,
    CaseStatusFromJSONTyped,
    CaseStatusToJSON,
    CaseStatusToJSONTyped,
} from './CaseStatus';
import type { Offering } from './Offering';
import {
    OfferingFromJSON,
    OfferingFromJSONTyped,
    OfferingToJSON,
    OfferingToJSONTyped,
} from './Offering';

/**
 * 
 * @export
 * @interface Case
 */
export interface Case {
    /**
     * This field has to be `null` on the request, since temporary cases are created not updated
     * @type {number}
     * @memberof Case
     */
    caseId?: number;
    /**
     * 
     * @type {CaseStatus}
     * @memberof Case
     */
    status?: CaseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof Case
     */
    isRequiredNewBr: boolean;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    br?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    partnerNumberId?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    placeHolderName: string;
    /**
     * 
     * @type {Array<Offering>}
     * @memberof Case
     */
    offerings?: Array<Offering>;
}

/**
 * Check if a given object implements the Case interface.
 */
export function instanceOfCase(value: object): value is Case {
    if (!('isRequiredNewBr' in value) || value['isRequiredNewBr'] === undefined) return false;
    if (!('placeHolderName' in value) || value['placeHolderName'] === undefined) return false;
    return true;
}

export function CaseFromJSON(json: any): Case {
    return CaseFromJSONTyped(json, false);
}

export function CaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Case {
    if (json == null) {
        return json;
    }
    return {
        
        'caseId': json['caseId'] == null ? undefined : json['caseId'],
        'status': json['status'] == null ? undefined : CaseStatusFromJSON(json['status']),
        'isRequiredNewBr': json['isRequiredNewBr'],
        'br': json['br'] == null ? undefined : json['br'],
        'partnerNumberId': json['partnerNumberId'] == null ? undefined : json['partnerNumberId'],
        'placeHolderName': json['placeHolderName'],
        'offerings': json['offerings'] == null ? undefined : ((json['offerings'] as Array<any>).map(OfferingFromJSON)),
    };
}

export function CaseToJSON(json: any): Case {
    return CaseToJSONTyped(json, false);
}

export function CaseToJSONTyped(value?: Case | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'caseId': value['caseId'],
        'status': CaseStatusToJSON(value['status']),
        'isRequiredNewBr': value['isRequiredNewBr'],
        'br': value['br'],
        'partnerNumberId': value['partnerNumberId'],
        'placeHolderName': value['placeHolderName'],
        'offerings': value['offerings'] == null ? undefined : ((value['offerings'] as Array<any>).map(OfferingToJSON)),
    };
}

